import React from 'react';
import { getAllSecteurs } from '../../utils/retail';
import { Check } from 'lucide-react';

/**
 * SCD Lot 1 — Étape « Concept » de la création de partie : secteur d'activité.
 * 30/06 — Le modèle est imposé : on démarre toujours indépendant (la création
 * d'une franchise du groupe arrivera plus tard dans l'avancée du jeu).
 * Le secteur choisi ici est celui du 1er magasin — d'autres secteurs pourront
 * être ouverts ensuite via le tunnel d'expansion.
 */
export default function ConceptSelection({ secteur, setSecteur, lockSecteur = null }) {
  const secteurs = getAllSecteurs();

  return (
    <div className="space-y-6" data-testid="step-concept">
      <div>
        <h2 className="text-xl font-bold text-slate-100">Votre concept de magasin</h2>
        <p className="text-sm text-slate-500 mt-1">Choisissez le secteur de votre premier magasin — vous pourrez ouvrir d{"'"}autres secteurs plus tard.</p>
      </div>

      {/* Secteur */}
      <div>
        <p className="overline mb-2">Secteur d{"'"}activité</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {secteurs.map(s => (
            <button
              key={s.id}
              type="button"
              onClick={() => { if (!lockSecteur || lockSecteur === s.id) setSecteur(s.id); }}
              disabled={!!lockSecteur && lockSecteur !== s.id}
              className={`text-left rounded-lg border p-3 transition-all ${secteur === s.id ? 'border-accent bg-accent/10 ring-1 ring-accent' : 'border-ink-600 bg-ink-900/40 hover:border-ink-500'} ${lockSecteur && lockSecteur !== s.id ? 'opacity-40 cursor-not-allowed' : ''}`}
              data-testid={`secteur-${s.id}`}
            >
              <div className="flex items-center gap-2">
                <span className="text-xl">{s.emoji}</span>
                <span className="font-bold text-sm text-slate-100">{s.nom}</span>
                {secteur === s.id && <Check className="w-4 h-4 text-accent ml-auto" />}
              </div>
              <p className="text-[11px] text-slate-500 mt-1 leading-snug">{s.description}</p>
            </button>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-ink-600 bg-ink-900/40 p-3" data-testid="modele-independant-note">
        <p className="text-sm font-bold text-slate-100">🧑‍💼 Vous démarrez commerçant indépendant</p>
        <p className="text-[11px] text-slate-500 mt-1 leading-snug">
          Toute enseigne commence en solo : liberté totale sur l{"'"}assortiment, les prix et l{"'"}image.
          Plus tard dans la partie, votre groupe pourra créer son propre système de franchise.
        </p>
      </div>
    </div>
  );
}
